import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Paste item command
 *
 * @class PasteItemCommand
 * @extends AbstractCommand
 */
export default class PasteItemCommand extends AbstractCommand {
    constructor(itemCollection, items) {
        super();
        this.itemCollection = itemCollection;
        this.items = Array.isArray(items) ? items : [items];
    }

    isValid() {
        return !this.items.find(item => !item.getParentItem().isItemSupported(item));
    }

    /**
     * Execute command
     */
    execute() {
        if (!this.isValid()) {
            this.abort();
            return;
        }

        this.itemCollection.add(this.items);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        if (!this.isValid()) {
            this.abort();
            return;
        }

        this.itemCollection.remove(this.items);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Paste ${this.items.length > 1 ? 'items' : this.items[0].attributes.type}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.PasteItemCommand = PasteItemCommand;
